(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'd2v-core-js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('d2v-core-js'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'd2v-color-js'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'd2v-color-js'.");
    }
    if (typeof this['d2v-core-js'] === 'undefined') {
      throw new Error("Error loading module 'd2v-color-js'. Its dependency 'd2v-core-js' was not found. Please, check whether 'd2v-core-js' is loaded prior to 'd2v-color-js'.");
    }
    root['d2v-color-js'] = factory(typeof this['d2v-color-js'] === 'undefined' ? {} : this['d2v-color-js'], kotlin, this['d2v-core-js']);
  }
}(this, function (_, Kotlin, $module$d2v_core_js) {
  'use strict';
  var lazy = Kotlin.kotlin.lazy_klfg04$;
  var listOf = Kotlin.kotlin.collections.listOf_i5x0yv$;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var numberToInt = Kotlin.numberToInt;
  var coerceAtLeast = Kotlin.kotlin.ranges.coerceAtLeast_dqglrj$;
  var coerceAtMost = Kotlin.kotlin.ranges.coerceAtMost_dqglrj$;
  var IntRange = Kotlin.kotlin.ranges.IntRange;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var toInt = Kotlin.kotlin.text.toInt_6ic1pp$;
  var Kind_INTERFACE = Kotlin.Kind.INTERFACE;
  var coerceIn = Kotlin.kotlin.ranges.coerceIn_nig4hr$;
  var coerceIn_0 = Kotlin.kotlin.ranges.coerceIn_e4yvb3$;
  var numberToDouble = Kotlin.numberToDouble;
  var coerceIn_1 = Kotlin.kotlin.ranges.coerceIn_wj6e7o$;
  var round = Kotlin.kotlin.math.round_14dthe$;
  var contains = Kotlin.kotlin.collections.contains_2ws7j4$;
  var get_deg = $module$d2v_core_js.io.data2viz.math.get_deg_rcaex3$;
  var throwCCE = Kotlin.throwCCE;
  var equals = Kotlin.equals;
  var hashCode = Kotlin.hashCode;
  var contains_0 = Kotlin.kotlin.ranges.contains_bupbvv$;
  var contains_1 = Kotlin.kotlin.ranges.contains_b3prtk$;
  var Angle = $module$d2v_core_js.io.data2viz.math.Angle;
  var math = Kotlin.kotlin.math;
  var IllegalArgumentException_init = Kotlin.kotlin.IllegalArgumentException_init_pdl1vj$;
  var EncodedColors$Companion_instance = null;
  var Math_0 = Math;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var Regex_init = Kotlin.kotlin.text.Regex_init_61zpoe$;
  var IllegalStateException_init = Kotlin.kotlin.IllegalStateException_init_pdl1vj$;
  function get_color($receiver) {
    var regex = Regex_init('^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$');
    if (!regex.matches_6bul2c$($receiver)) {
      throw IllegalStateException_init('Conversion of string to io.data2viz.color.getColor works for encoded colors like #12abCD'.toString());
    }
    return new Color(toInt($receiver.substring(1), 16));
  }
  function ConversionHelper() {
    ConversionHelper_instance = this;
    this.Kn = 18.0;
    this.Xn = 0.95047;
    this.Yn = 1.0;
    this.Zn = 1.08883;
    this.t0 = 4.0 / 29.0;
    this.t1 = 6.0 / 29.0;
    this.t2 = 3.0 * this.t1 * this.t1;
    this.t3 = this.t1 * this.t1 * this.t1;
    this.darker = 0.7;
    this.brighter = 1 / this.darker;
  }
  ConversionHelper.prototype.xyz2lab_14dthe$ = function (value) {
    var tmp$;
    if (value > this.t3) {
      var x = 1 / 3.0;
      tmp$ = Math_0.pow(value, x);
    }
     else
      tmp$ = value / this.t2 + this.t0;
    return tmp$;
  };
  ConversionHelper.prototype.rgb2xyz_za3lpa$ = function (value) {
    var percent = value / 255.0;
    var tmp$;
    if (percent <= 0.04045)
      tmp$ = percent / 12.92;
    else {
      var $receiver = (percent + 0.055) / 1.055;
      tmp$ = Math_0.pow($receiver, 2.4);
    }
    return tmp$;
  };
  ConversionHelper.prototype.lab2xyz_mx4ult$ = function (value) {
    return value > this.t1 ? value * value * value : this.t2 * (value - this.t0);
  };
  ConversionHelper.prototype.xyz2rgb_mx4ult$ = function (value) {
    var tmp$;
    if (value <= 0.0031308) {
      tmp$ = numberToInt(round(12.92 * value * 255));
    }
     else {
      var x = 1 / 2.4;
      tmp$ = numberToInt(round(255 * (1.055 * Math_0.pow(value, x) - 0.055)));
    }
    return tmp$;
  };
  ConversionHelper.$metadata$ = {kind: Kind_OBJECT, simpleName: 'ConversionHelper', interfaces: []};
  var ConversionHelper_instance = null;
  function ConversionHelper_getInstance() {
    if (ConversionHelper_instance === null) {
      new ConversionHelper();
    }
    return ConversionHelper_instance;
  }
  function ColorOrGradient() {
  }
  ColorOrGradient.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'ColorOrGradient', interfaces: []};
  function LinearGradient() {
    this.x1 = 0.0;
    this.y1 = 0.0;
    this.x2 = 0.0;
    this.y2 = 0.0;
    this.colorStops = ArrayList_init();
  }
  function LinearGradient$ColorStop(percent, color) {
    this.percent = percent;
    this.color = color;
  }
  LinearGradient$ColorStop.$metadata$ = {kind: Kind_CLASS, simpleName: 'ColorStop', interfaces: []};
  LinearGradient$ColorStop.prototype.component1 = function () {
    return this.percent;
  };
  LinearGradient$ColorStop.prototype.component2 = function () {
    return this.color;
  };
  LinearGradient$ColorStop.prototype.copy_vcv3pf$ = function (percent, color) {
    return new LinearGradient$ColorStop(percent === void 0 ? this.percent : percent, color === void 0 ? this.color : color);
  };
  LinearGradient$ColorStop.prototype.toString = function () {
    return 'ColorStop(percent=' + Kotlin.toString(this.percent) + (', color=' + Kotlin.toString(this.color)) + ')';
  };
  LinearGradient$ColorStop.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.percent) | 0;
    result = result * 31 + Kotlin.hashCode(this.color) | 0;
    return result;
  };
  LinearGradient$ColorStop.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.percent, other.percent) && Kotlin.equals(this.color, other.color)))));
  };
  LinearGradient.prototype.addColor_vcv3pf$ = function (percent, color) {
    var checkedPercent = coerceIn(percent, 0.0, 1.0);
    this.colorStops.add_11rb$(new LinearGradient$ColorStop(checkedPercent, color));
  };
  LinearGradient.$metadata$ = {kind: Kind_CLASS, simpleName: 'LinearGradient', interfaces: [ColorOrGradient]};
  function Color(rgb, _alpha) {
    if (rgb === void 0)
      rgb = 16777215;
    if (_alpha === void 0)
      _alpha = 1.0;
    this.rgb = rgb;
    this._alpha = _alpha;
  }
  Object.defineProperty(Color.prototype, 'r', {get: function () {
    return this.rgb >> 16 & 255;
  }, set: function (value) {
    this.rgb = (this.rgb & 65535) + (coerceIn_0(value, 0, 255) << 16) | 0;
  }});
  Object.defineProperty(Color.prototype, 'g', {get: function () {
    return this.rgb >> 8 & 255;
  }, set: function (value) {
    this.rgb = (this.rgb & 16711935) + (coerceIn_0(value, 0, 255) << 8) | 0;
  }});
  Object.defineProperty(Color.prototype, 'b', {get: function () {
    return this.rgb & 255;
  }, set: function (value) {
    this.rgb = (this.rgb & 16776960) + coerceIn_0(value, 0, 255) | 0;
  }});
  Object.defineProperty(Color.prototype, 'alpha', {get: function () {
    return this._alpha;
  }, set: function (value) {
    this._alpha = coerceIn_1(numberToDouble(value), 0.0, 1.0);
  }});
  Color.prototype.rgba_1ugm5o$ = function (r, g, b, a) {
    this.r = numberToInt(round(numberToDouble(r)));
    this.g = numberToInt(round(numberToDouble(g)));
    this.b = numberToInt(round(numberToDouble(b)));
    this.alpha = numberToDouble(a);
  };
  Object.defineProperty(Color.prototype, 'displayable', {get: function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
    tmp$ = this.r;
    if (0 <= tmp$ && tmp$ <= 255) {
      tmp$_0 = this.g;
      tmp$_1 = (0 <= tmp$_0 && tmp$_0 <= 255);
    }
     else
      tmp$_1 = false;
    if (tmp$_1) {
      tmp$_2 = this.b;
      tmp$_3 = (0 <= tmp$_2 && tmp$_2 <= 255);
    }
     else
      tmp$_3 = false;
    return tmp$_3 && contains(new IntRange(0, 1), this.alpha);
  }});
  Color.prototype.brighter_14dthe$ = function (strength) {
    if (strength === void 0)
      strength = 1.0;
    var $receiver = ConversionHelper_getInstance().brighter;
    var str = Math_0.pow($receiver, strength);
    return this.rgba_1ugm5o$(this.r * str, this.g * str, this.b * str, this.alpha);
  };
  Color.prototype.darker_14dthe$ = function (strength) {
    if (strength === void 0)
      strength = 1.0;
    var $receiver = ConversionHelper_getInstance().darker;
    var str = Math_0.pow($receiver, strength);
    return this.rgba_1ugm5o$(this.r * str, this.g * str, this.b * str, this.alpha);
  };
  Color.prototype.toHsla = function () {
    var rPercent = this.r / 255.0;
    var gPercent = this.g / 255.0;
    var bPercent = this.b / 255.0;
    var minPercent = Math_0.min(rPercent, gPercent, bPercent);
    var maxPercent = Math_0.max(rPercent, gPercent, bPercent);
    var h = 0.0;
    var s = maxPercent - minPercent;
    var l = (maxPercent + minPercent) / 2.0;
    if (s !== 0.0) {
      if (rPercent === maxPercent)
        h = gPercent < bPercent ? (gPercent - bPercent) / s + 6.0 : (gPercent - bPercent) / s;
      else if (gPercent === maxPercent)
        h = (bPercent - rPercent) / s + 2.0;
      else
        h = (rPercent - gPercent) / s + 4.0;
      s /= l < 0.5 ? maxPercent + minPercent : 2 - maxPercent - minPercent;
      h *= 60.0;
    }
     else {
      s = l > 0 && l < 1 ? 0.0 : h;
    }
    return new HSL(get_deg(h), s, l, this.alpha);
  };
  Color.prototype.toLab = function () {
    var labB = ConversionHelper_getInstance().rgb2xyz_za3lpa$(this.r);
    var labA = ConversionHelper_getInstance().rgb2xyz_za3lpa$(this.g);
    var labL = ConversionHelper_getInstance().rgb2xyz_za3lpa$(this.b);
    var x = ConversionHelper_getInstance().xyz2lab_14dthe$((0.4124564 * labB + 0.3575761 * labA + 0.1804375 * labL) / ConversionHelper_getInstance().Xn);
    var y = ConversionHelper_getInstance().xyz2lab_14dthe$((0.2126729 * labB + 0.7151522 * labA + 0.072175 * labL) / ConversionHelper_getInstance().Yn);
    var z = ConversionHelper_getInstance().xyz2lab_14dthe$((0.0193339 * labB + 0.119192 * labA + 0.9503041 * labL) / ConversionHelper_getInstance().Zn);
    return new LAB(116 * y - 16, 500 * (x - y), 200 * (y - z), this.alpha);
  };
  Object.defineProperty(Color.prototype, 'rgbHex', {get: function () {
    return '#' + toString(this.rgb >> 20 & 15, 16) + toString(this.rgb >> 16 & 15, 16) + toString(this.rgb >> 12 & 15, 16) + toString(this.rgb >> 8 & 15, 16) + toString(this.rgb >> 4 & 15, 16) + toString(this.rgb & 15, 16);
  }});
  Color.prototype.equals = function (other) {
    var tmp$, tmp$_0;
    if (this === other)
      return true;
    if (other == null || !((tmp$ = Kotlin.getKClassFromExpression(this)) != null ? tmp$.equals(Kotlin.getKClassFromExpression(other)) : null))
      return false;
    Kotlin.isType(tmp$_0 = other, Color) ? tmp$_0 : throwCCE();
    if (this.rgb !== other.rgb)
      return false;
    if (!equals(this._alpha, other._alpha))
      return false;
    return true;
  };
  Color.prototype.hashCode = function () {
    var result = this.rgb;
    result = (31 * result | 0) + hashCode(this._alpha) | 0;
    return result;
  };
  Color.prototype.toString = function () {
    return numberToDouble(this.alpha) < 1.0 ? 'rgba(' + this.r + ', ' + this.g + ', ' + this.b + ', ' + this.alpha + ')' : this.rgbHex;
  };
  Color.$metadata$ = {kind: Kind_CLASS, simpleName: 'Color', interfaces: [ColorOrGradient]};
  function HSL(h, s, l, alpha) {
    if (h === void 0)
      h = new Angle(0.0);
    if (s === void 0)
      s = 1;
    if (l === void 0)
      l = 1;
    if (alpha === void 0)
      alpha = 1;
    this.h = h;
    this.s = coerceIn(numberToDouble(s), 0.0, 1.0);
    this.l = coerceIn(numberToDouble(l), 0.0, 1.0);
    this.alpha = coerceIn_1(numberToDouble(alpha), 0.0, 1.0);
  }
  Object.defineProperty(HSL.prototype, 'displayable', {get: function () {
    return contains_0(new IntRange(0, 1), this.s) && contains_0(new IntRange(0, 1), this.l) && contains_1(new IntRange(0, 1), this.alpha);
  }});
  HSL.prototype.brighter_14dthe$ = function (strength) {
    if (strength === void 0)
      strength = 1.0;
    var tmp$ = this.h;
    var tmp$_0 = this.s;
    var tmp$_1 = this.l;
    var $receiver = ConversionHelper_getInstance().brighter;
    return new HSL(tmp$, tmp$_0, tmp$_1 * Math_0.pow($receiver, strength), this.alpha);
  };
  HSL.prototype.darker_14dthe$ = function (strength) {
    if (strength === void 0)
      strength = 1.0;
    var tmp$ = this.h;
    var tmp$_0 = this.s;
    var tmp$_1 = this.l;
    var $receiver = ConversionHelper_getInstance().brighter;
    return new HSL(tmp$, tmp$_0, tmp$_1 * Math_0.pow($receiver, strength), this.alpha);
  };
  HSL.prototype.toRgba = function () {
    if (this.s === 0.0)
      return colors_getInstance().rgba_1ugm5o$(round(this.l * 255), round(this.l * 255), round(this.l * 255), this.alpha);
    else {
      var q = this.l < 0.5 ? this.l * (1 + this.s) : this.l + this.s - this.l * this.s;
      var p = 2 * this.l - q;
      return colors_getInstance().rgba_1ugm5o$(round(this.hue2rgb_0(p, q, this.h.plus_5t6zck$(get_deg(120))) * 255), round(this.hue2rgb_0(p, q, this.h) * 255), round(this.hue2rgb_0(p, q, this.h.minus_5t6zck$(get_deg(120))) * 255), this.alpha);
    }
  };
  HSL.prototype.hue2rgb_0 = function (p, q, hue) {
    var tmp$;
    var hd = hue.normalize();
    if (hd.deg < 60)
      tmp$ = p + (q - p) * (hd.deg / 60.0);
    else if (hd.deg < 180)
      tmp$ = q;
    else if (hd.deg < 240)
      tmp$ = p + (q - p) * ((240 - hd.deg) / 60.0);
    else
      tmp$ = p;
    return tmp$;
  };
  HSL.prototype.equals = function (other) {
    var tmp$;
    return other != null && Kotlin.isType(other, HSL) && ((tmp$ = this.h) != null ? tmp$.equals(other.h) : null) && this.s === other.s && this.l === other.l && this.alpha === other.alpha;
  };
  HSL.prototype.toString = function () {
    return 'hsla(' + this.h.deg + '\xB0, ' + this.s * 100 + '%, ' + this.l * 100 + '%, ' + this.alpha + ')';
  };
  HSL.prototype.hashCode = function () {
    var result = this.h.hashCode();
    result = (31 * result | 0) + hashCode(this.s) | 0;
    result = (31 * result | 0) + hashCode(this.l) | 0;
    result = (31 * result | 0) + hashCode(this.alpha) | 0;
    return result;
  };
  HSL.$metadata$ = {kind: Kind_CLASS, simpleName: 'HSL', interfaces: []};
  function LAB(l, a, b, alpha) {
    if (l === void 0)
      l = 100;
    if (a === void 0)
      a = 0;
    if (b === void 0)
      b = 0;
    if (alpha === void 0)
      alpha = 1;
    this.l = coerceIn_1(numberToDouble(l), 0.0, 100.0);
    this.a = coerceIn_1(numberToDouble(a), -128.0, 128.0);
    this.b = coerceIn_1(numberToDouble(b), -128.0, 128.0);
    this.alpha = coerceIn_1(numberToDouble(alpha), 0.0, 1.0);
  }
  LAB.prototype.brighter_14dthe$ = function (strength) {
    if (strength === void 0)
      strength = 1.0;
    return new LAB(this.l + ConversionHelper_getInstance().Kn * strength, this.a, this.b, this.alpha);
  };
  LAB.prototype.darker_14dthe$ = function (strength) {
    if (strength === void 0)
      strength = 1.0;
    return new LAB(this.l - ConversionHelper_getInstance().Kn * strength, this.a, this.b, this.alpha);
  };
  LAB.prototype.toRgba = function () {
    var y = (this.l + 16) / 116.0;
    var x = y + this.a / 500.0;
    var z = y - this.b / 200.0;
    y = ConversionHelper_getInstance().Yn * ConversionHelper_getInstance().lab2xyz_mx4ult$(y);
    x = ConversionHelper_getInstance().Xn * ConversionHelper_getInstance().lab2xyz_mx4ult$(x);
    z = ConversionHelper_getInstance().Zn * ConversionHelper_getInstance().lab2xyz_mx4ult$(z);
    return colors_getInstance().rgba_1ugm5o$(ConversionHelper_getInstance().xyz2rgb_mx4ult$(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), ConversionHelper_getInstance().xyz2rgb_mx4ult$(-0.969266 * x + 1.8760108 * y + 0.041556 * z), ConversionHelper_getInstance().xyz2rgb_mx4ult$(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), this.alpha);
  };
  LAB.prototype.toHcla = function () {
    var y = this.b;
    var x = this.a;
    var h = Math_0.atan2(y, x) * (180 / math.PI);
    var hue = get_deg(h).normalize();
    var x_0 = this.a * this.a + this.b * this.b;
    return new HCL(hue, Math_0.sqrt(x_0), this.l, this.alpha);
  };
  LAB.prototype.toString = function () {
    return 'laba(' + this.l + ', ' + this.a + ', ' + this.b + ', ' + this.alpha + ')';
  };
  LAB.$metadata$ = {kind: Kind_CLASS, simpleName: 'LAB', interfaces: []};
  function HCL(h, c, l, alpha) {
    if (h === void 0)
      h = new Angle(0.0);
    if (c === void 0)
      c = 1;
    if (l === void 0)
      l = 100;
    if (alpha === void 0)
      alpha = 1;
    this.h = h;
    this.c = numberToDouble(c);
    this.l = coerceIn_1(numberToDouble(l), 0.0, 100.0);
    this.alpha = coerceIn_1(numberToDouble(alpha), 0.0, 1.0);
  }
  HCL.prototype.brighter_14dthe$ = function (strength) {
    if (strength === void 0)
      strength = 1.0;
    return new HCL(this.h, this.c, this.l + ConversionHelper_getInstance().Kn * strength, this.alpha);
  };
  HCL.prototype.darker_14dthe$ = function (strength) {
    if (strength === void 0)
      strength = 1.0;
    return new HCL(this.h, this.c, this.l - ConversionHelper_getInstance().Kn * strength, this.alpha);
  };
  HCL.prototype.equals = function (other) {
    var tmp$;
    return other != null && Kotlin.isType(other, HCL) && ((tmp$ = this.h) != null ? tmp$.equals(other.h) : null) && this.c === other.c && this.l === other.l && this.alpha === other.alpha;
  };
  HCL.prototype.toString = function () {
    return 'hcla(' + this.h.deg + '\xB0, ' + this.c + ', ' + this.l * 100 + '%, ' + this.alpha + ')';
  };
  HCL.$metadata$ = {kind: Kind_CLASS, simpleName: 'HCL', interfaces: []};
  function colors() {
    colors_instance = this;
    this.aliceblue = this.get_col_s8ev3n$(15792383);
    this.antiquewhite = this.get_col_s8ev3n$(16444375);
    this.aqua = this.get_col_s8ev3n$(65535);
    this.aquamarine = this.get_col_s8ev3n$(8388564);
    this.azure = this.get_col_s8ev3n$(15794175);
    this.beige = this.get_col_s8ev3n$(16119260);
    this.bisque = this.get_col_s8ev3n$(16770244);
    this.black = this.get_col_s8ev3n$(0);
    this.blanchedalmond = this.get_col_s8ev3n$(16772045);
    this.blue = this.get_col_s8ev3n$(255);
    this.blueviolet = this.get_col_s8ev3n$(9055202);
    this.brown = this.get_col_s8ev3n$(10824234);
    this.burlywood = this.get_col_s8ev3n$(14596231);
    this.cadetblue = this.get_col_s8ev3n$(6266528);
    this.chartreuse = this.get_col_s8ev3n$(8388352);
    this.chocolate = this.get_col_s8ev3n$(13789470);
    this.coral = this.get_col_s8ev3n$(16744272);
    this.cornflowerblue = this.get_col_s8ev3n$(6591981);
    this.cornsilk = this.get_col_s8ev3n$(16775388);
    this.crimson = this.get_col_s8ev3n$(14423100);
    this.cyan = this.get_col_s8ev3n$(65535);
    this.darkblue = this.get_col_s8ev3n$(139);
    this.darkcyan = this.get_col_s8ev3n$(35723);
    this.darkgoldenrod = this.get_col_s8ev3n$(12092939);
    this.darkgray = this.get_col_s8ev3n$(11119017);
    this.darkgreen = this.get_col_s8ev3n$(25600);
    this.darkgrey = this.get_col_s8ev3n$(11119017);
    this.darkkhaki = this.get_col_s8ev3n$(12433259);
    this.darkmagenta = this.get_col_s8ev3n$(9109643);
    this.darkolivegreen = this.get_col_s8ev3n$(5597999);
    this.darkorange = this.get_col_s8ev3n$(16747520);
    this.darkorchid = this.get_col_s8ev3n$(10040012);
    this.darkred = this.get_col_s8ev3n$(9109504);
    this.darksalmon = this.get_col_s8ev3n$(15308410);
    this.darkseagreen = this.get_col_s8ev3n$(9419919);
    this.darkslateblue = this.get_col_s8ev3n$(4734347);
    this.darkslategray = this.get_col_s8ev3n$(3100495);
    this.darkslategrey = this.get_col_s8ev3n$(3100495);
    this.darkturquoise = this.get_col_s8ev3n$(52945);
    this.darkviolet = this.get_col_s8ev3n$(9699539);
    this.deeppink = this.get_col_s8ev3n$(16716947);
    this.deepskyblue = this.get_col_s8ev3n$(49151);
    this.dimgray = this.get_col_s8ev3n$(6908265);
    this.dimgrey = this.get_col_s8ev3n$(6908265);
    this.dodgerblue = this.get_col_s8ev3n$(2003199);
    this.firebrick = this.get_col_s8ev3n$(11674146);
    this.floralwhite = this.get_col_s8ev3n$(16775920);
    this.forestgreen = this.get_col_s8ev3n$(2263842);
    this.fuchsia = this.get_col_s8ev3n$(16711935);
    this.gainsboro = this.get_col_s8ev3n$(14474460);
    this.ghostwhite = this.get_col_s8ev3n$(16316671);
    this.gold = this.get_col_s8ev3n$(16766720);
    this.goldenrod = this.get_col_s8ev3n$(14329120);
    this.gray = this.get_col_s8ev3n$(8421504);
    this.green = this.get_col_s8ev3n$(32768);
    this.greenyellow = this.get_col_s8ev3n$(11403055);
    this.grey = this.get_col_s8ev3n$(8421504);
    this.honeydew = this.get_col_s8ev3n$(15794160);
    this.hotpink = this.get_col_s8ev3n$(16738740);
    this.indianred = this.get_col_s8ev3n$(13458524);
    this.indigo = this.get_col_s8ev3n$(4915330);
    this.ivory = this.get_col_s8ev3n$(16777200);
    this.khaki = this.get_col_s8ev3n$(15787660);
    this.lavender = this.get_col_s8ev3n$(15132410);
    this.lavenderblush = this.get_col_s8ev3n$(16773365);
    this.lawngreen = this.get_col_s8ev3n$(8190976);
    this.lemonchiffon = this.get_col_s8ev3n$(16775885);
    this.lightblue = this.get_col_s8ev3n$(11393254);
    this.lightcoral = this.get_col_s8ev3n$(15761536);
    this.lightcyan = this.get_col_s8ev3n$(14745599);
    this.lightgoldenrodyellow = this.get_col_s8ev3n$(16448210);
    this.lightgray = this.get_col_s8ev3n$(13882323);
    this.lightgreen = this.get_col_s8ev3n$(9498256);
    this.lightgrey = this.get_col_s8ev3n$(13882323);
    this.lightpink = this.get_col_s8ev3n$(16758465);
    this.lightsalmon = this.get_col_s8ev3n$(16752762);
    this.lightseagreen = this.get_col_s8ev3n$(2142890);
    this.lightskyblue = this.get_col_s8ev3n$(8900346);
    this.lightslategray = this.get_col_s8ev3n$(7833753);
    this.lightslategrey = this.get_col_s8ev3n$(7833753);
    this.lightsteelblue = this.get_col_s8ev3n$(11584734);
    this.lightyellow = this.get_col_s8ev3n$(16777184);
    this.lime = this.get_col_s8ev3n$(65280);
    this.limegreen = this.get_col_s8ev3n$(3329330);
    this.linen = this.get_col_s8ev3n$(16445670);
    this.magenta = this.get_col_s8ev3n$(16711935);
    this.maroon = this.get_col_s8ev3n$(8388608);
    this.mediumaquamarine = this.get_col_s8ev3n$(6737322);
    this.mediumblue = this.get_col_s8ev3n$(205);
    this.mediumorchid = this.get_col_s8ev3n$(12211667);
    this.mediumpurple = this.get_col_s8ev3n$(9662683);
    this.mediumseagreen = this.get_col_s8ev3n$(3978097);
    this.mediumslateblue = this.get_col_s8ev3n$(8087790);
    this.mediumspringgreen = this.get_col_s8ev3n$(64154);
    this.mediumturquoise = this.get_col_s8ev3n$(4772300);
    this.mediumvioletred = this.get_col_s8ev3n$(13047173);
    this.midnightblue = this.get_col_s8ev3n$(1644912);
    this.mintcream = this.get_col_s8ev3n$(16121850);
    this.mistyrose = this.get_col_s8ev3n$(16770273);
    this.moccasin = this.get_col_s8ev3n$(16770229);
    this.navajowhite = this.get_col_s8ev3n$(16768685);
    this.navy = this.get_col_s8ev3n$(128);
    this.oldlace = this.get_col_s8ev3n$(16643558);
    this.olive = this.get_col_s8ev3n$(8421376);
    this.olivedrab = this.get_col_s8ev3n$(7048739);
    this.orange = this.get_col_s8ev3n$(16753920);
    this.orangered = this.get_col_s8ev3n$(16729344);
    this.orchid = this.get_col_s8ev3n$(14315734);
    this.palegoldenrod = this.get_col_s8ev3n$(15657130);
    this.palegreen = this.get_col_s8ev3n$(10025880);
    this.paleturquoise = this.get_col_s8ev3n$(11529966);
    this.palevioletred = this.get_col_s8ev3n$(14381203);
    this.papayawhip = this.get_col_s8ev3n$(16773077);
    this.peachpuff = this.get_col_s8ev3n$(16767673);
    this.peru = this.get_col_s8ev3n$(13468991);
    this.pink = this.get_col_s8ev3n$(16761035);
    this.plum = this.get_col_s8ev3n$(14524637);
    this.powderblue = this.get_col_s8ev3n$(11591910);
    this.purple = this.get_col_s8ev3n$(8388736);
    this.rebeccapurple = this.get_col_s8ev3n$(6697881);
    this.red = this.get_col_s8ev3n$(16711680);
    this.rosybrown = this.get_col_s8ev3n$(12357519);
    this.royalblue = this.get_col_s8ev3n$(4286945);
    this.saddlebrown = this.get_col_s8ev3n$(9127187);
    this.salmon = this.get_col_s8ev3n$(16416882);
    this.sandybrown = this.get_col_s8ev3n$(16032864);
    this.seagreen = this.get_col_s8ev3n$(3050327);
    this.seashell = this.get_col_s8ev3n$(16774638);
    this.sienna = this.get_col_s8ev3n$(10506797);
    this.silver = this.get_col_s8ev3n$(12632256);
    this.skyblue = this.get_col_s8ev3n$(8900331);
    this.slateblue = this.get_col_s8ev3n$(6970061);
    this.slategray = this.get_col_s8ev3n$(7372944);
    this.slategrey = this.get_col_s8ev3n$(7372944);
    this.snow = this.get_col_s8ev3n$(16775930);
    this.springgreen = this.get_col_s8ev3n$(65407);
    this.steelblue = this.get_col_s8ev3n$(4620980);
    this.tan = this.get_col_s8ev3n$(13808780);
    this.teal = this.get_col_s8ev3n$(32896);
    this.thistle = this.get_col_s8ev3n$(14204888);
    this.tomato = this.get_col_s8ev3n$(16737095);
    this.turquoise = this.get_col_s8ev3n$(4251856);
    this.violet = this.get_col_s8ev3n$(15631086);
    this.wheat = this.get_col_s8ev3n$(16113331);
    this.white = this.get_col_s8ev3n$(16777215);
    this.whitesmoke = this.get_col_s8ev3n$(16119285);
    this.yellow = this.get_col_s8ev3n$(16776960);
    this.yellowgreen = this.get_col_s8ev3n$(10145074);
  }
  colors.prototype.rgba_1ugm5o$ = function (r, g, b, a) {
    if (a === void 0)
      a = 1.0;
    var $receiver = new Color();
    $receiver.rgba_1ugm5o$(r, g, b, a);
    return $receiver;
  };
  colors.prototype.hsla_dk4mvm$ = function (h, s, l, a) {
    if (a === void 0)
      a = 1.0;
    return new HSL(h, s, l, a);
  };
  colors.prototype.lab_1ugm5o$ = function (l, a, b, alpha) {
    if (l === void 0)
      l = 100;
    if (a === void 0)
      a = 0;
    if (b === void 0)
      b = 0;
    if (alpha === void 0)
      alpha = 1.0;
    return new LAB(l, a, b, alpha);
  };
  colors.prototype.get_col_s8ev3n$ = function ($receiver) {
    return new Color($receiver);
  };
  colors.$metadata$ = {kind: Kind_OBJECT, simpleName: 'colors', interfaces: []};
  var colors_instance = null;
  function colors_getInstance() {
    if (colors_instance === null) {
      new colors();
    }
    return colors_instance;
  }
  function toString($receiver, radix) {
    return $receiver.toString(radix);
  }
  var package$io = _.io || (_.io = {});
  var package$data2viz = package$io.data2viz || (package$io.data2viz = {});
  var package$color = package$data2viz.color || (package$data2viz.color = {});
  package$color.get_color_pdl1vz$ = get_color;
  package$color.ColorOrGradient = ColorOrGradient;
  LinearGradient.ColorStop = LinearGradient$ColorStop;
  package$color.LinearGradient = LinearGradient;
  package$color.Color = Color;
  package$color.HSL = HSL;
  package$color.LAB = LAB;
  package$color.HCL = HCL;
  Object.defineProperty(package$color, 'colors', {get: colors_getInstance});
  package$color.toString_b6l1hq$ = toString;
  return _;
}));

//# sourceMappingURL=d2v-color-js.js.map



//////////////////
// WEBPACK FOOTER
// ./build/kotlin-js-min/main/d2v-color-js.js
// module id = 1
// module chunks = 0